import { use } from 'react';

import { TokenContext } from '../contexts/token-context';

export const useTokenContext = () => {
   const context = use(TokenContext);

   if (!context) {
      throw new Error('useTokenContext must be used within a TokenContextProvider');
   }

   return context;
};
